<div class="splash-screen">
  <div class="bx--grid">
    <div class="bx--row">
      <div class="bx--col-xlg-6 bx--col-lg-4 bx--col-md-4 bx--col-sm">
        <img
          class="logo"
          src="../../../../assets/images/IDS-Logo.png"
          alt="IDS - logo"
          />
        </div>
      </div>
    </div>
    <div class="bx--grid">
      <div class="bx--row">
        <div class="bx--col">
          <h1 class="mt-3">Login to VM Online</h1>
        </div>
      </div>
    </div>
    @if (messages) {
      <div
        class="bx--grid"
        >
        <div class="bx--row">
          <div class="bx--col-xlg-6 bx--col-lg-7 bx--col-md-7 bx--col-sm">
            <app-message
              [messages]="messages"
              data-qa="messages"
              >
            </app-message>
          </div>
        </div>
      </div>
    }
    <div class="bx--grid">
      <div class="bx--row">
        <div class="bx--col-xlg-3 bx--col-lg-4 bx--col-md-4 bx--col-sm">
          <form
            #f="ngForm"
            class="form-mt bx--form"
            [formGroup]="loginForm"
            >
            <div class="bx--form-item-control">
              <app-input-text
                data-qa="login-username"
                displayName="Username"
                inputId="login-username"
                label="Enter your username"
                name="username"
                theme="dark"
                [focusOnLoad]="true"
                [formGroup]="loginForm"
              ></app-input-text>
            </div>
            <div class="bx--form-item-control">
              <app-input-text
                data-qa="login-password"
                inputId="login-password"
                type="password"
                label="Password"
                name="password"
                theme="dark"
                [formGroup]="loginForm"
                [isDisabled]="isPasswordDisabled()"
              ></app-input-text>
            </div>
            <div class="bx--form-item-control">
              @if (!isProcessing) {
                <app-button
                  data-qa="login-submit"
                  buttonLabel="Continue"
                  buttonIcon="pi pi-arrow-right"
                  (buttonClicked)="signIn($event)"
                  type="submit"
                  buttonId="login-submit"
                  class="w-100"
                ></app-button>
              }
            </div>
            <div class="bx--form-item-control">
              @if (isProcessing) {
                <div
                  data-qa="loading-indicator"
                  aria-atomic="true"
                  aria-live="assertive"
                  class="bx--loading bx--loading--small"
                  >
                  <label class="bx--visually-hidden">Active loading indicator</label
                    ><svg
                    class="bx--loading__svg"
                    viewBox="0 0 100 100"
                    >
                    <title>Active loading indicator</title>
                    <circle
                      class="bx--loading__stroke"
                      cx="50%"
                      cy="50%"
                      r="44"
                    ></circle>
                  </svg>
                </div>
              }
            </div>
            @if (showForgetPassword) {
              <div
                class="bx--form-item-control"
                >
                <a
                  [routerLink]=""
                  (click)="forgotPassword()"
                  data-qa="forgotten-password-link"
                  >
                  Forgot password
                </a>
              </div>
            }
          </form>
        </div>
      </div>
    </div>
  </div>
